import {cloneElement, isValidElement, useId, useLayoutEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';

// Render outside table scrollers; the native top layer also keeps help above modals.
export default function Tooltip({content, children}) {
  const id = useId();
  const anchor = useRef(null);
  const bubble = useRef(null);
  const [visible, setVisible] = useState(false);
  useLayoutEffect(() => {
    if (!visible) return;
    const tip = bubble.current;
    tip.showPopover?.();
    const position = () => {
      const rect = anchor.current.getBoundingClientRect();
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      const bounds = tip.getBoundingClientRect();
      const left = Math.max(8, Math.min(rect.left, width - bounds.width - 8));
      const above = rect.top - bounds.height - 8;
      const top = above >= 8 ? above : Math.max(8, Math.min(rect.bottom + 8, height - bounds.height - 8));
      tip.style.left = `${left}px`;
      tip.style.top = `${top}px`;
    };
    position();
    window.addEventListener('resize', position);
    window.addEventListener('scroll', position, true);
    const observer = new ResizeObserver(position);
    observer.observe(tip);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', position);
      window.removeEventListener('scroll', position, true);
    };
  }, [visible, content]);
  return <span ref={anchor} className="admin-tooltip-anchor"
    onMouseEnter={() => setVisible(true)}
    onMouseLeave={() => {if (!anchor.current.contains(document.activeElement)) setVisible(false);}}
    onFocus={() => setVisible(true)} onBlur={event => {if (!event.currentTarget.contains(event.relatedTarget)) setVisible(false);}}
    onKeyDown={event => {if (event.key === 'Escape') setVisible(false);}}>
    {isValidElement(children) ? cloneElement(children, {'aria-describedby': visible ? id : undefined}) : children}
    {visible && createPortal(<div ref={bubble} className="admin-tooltip" id={id} role="tooltip" popover="manual">{content}</div>, document.body)}
  </span>;
}
